"use client";

import ReflectScreen from "@/components/reflect/ReflectScreen";

interface Props {
  onNavigate: (tab: string, initialMessage?: string) => void;
}

export default function LifeScreen({ onNavigate }: Props) {
  return <ReflectScreen onNavigate={onNavigate} />;
}
